<template>
  <div class="notas d-flex wrap">
    <div class="col-lg-4 col-md-6 col-sm-12 m-10" v-for="(note, index) in notes" :key="index">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ note.title }}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{ note.author }}</h6>
          <p class="card-text">{{ note.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notas',
  props: {
    notes: null
  }
}
</script>

<style scoped>
.notas {
  width: 100%;
}
.wrap {
  flex-wrap: wrap;
}
.m-10 {
  padding: 10px;
}
.rounded {
  border-radius: 10px;
}
</style>
